import { breakpoints, Inline, LinkButton, Stack } from '@etg/wings';
import { Icon } from '@eti/components';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { useMediaQuery } from 'usehooks-ts';
import SummaryEditOrRemoveButton from './SummaryEditOrRemoveButton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const selectSeatStyles = css`
  align-items: center;
  display: flex;
  gap: 10px;
  margin-right: 4px;
  padding: 8px;

  [dir='rtl'] & {
    margin-left: 4px;
    margin-right: 0;
  }
`;
const cellStyles = css`
  bottom: 0;
  position: absolute;
  right: 0;
  top: 0;

  [dir='rtl'] & {
    left: 0;
    right: auto;
  }

  @media (min-width: 48em) {
    position: static;
    width: 24%;
  }
`;
const actionsWrapperStyles = css`
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: flex-end;

  @media (min-width: ${breakpoints._768}) and (max-width: 1199px) {
    align-items: flex-end;
    flex-direction: column;
  }
`;
const dataTestId = (button, boundIndex, segmentIndex, travelerIndex) => `seatMapSummaryActionsCell-bound-${boundIndex}-segment-${segmentIndex}-traveler-${travelerIndex}-${button}-button`;
const SummaryActionsCell = ({
  boundIndex,
  onRemoveSeat,
  onToggleSeatSelect,
  segmentIndex,
  selectedSeat,
  travelerIndex
}) => {
  const {
    t
  } = useTranslation();
  const editLabel = selectedSeat && selectedSeat.seatPreference ? t('Product.SeatMap.Summary.SeatPreference.Change') : t('Product.SeatMap.Summary.Seat.Change');
  const removeLabel = t('Product.SeatMap.Summary.Seat.Remove');
  const selectLabel = t('Product.SeatMap.Seat.Select');
  const isTabletDevice = useMediaQuery('(min-width: 767px) and (max-width: 1199px)');
  const seatActionButtons = [{
    type: 'edit',
    label: editLabel,
    onClick: onToggleSeatSelect
  }, {
    type: 'remove',
    label: removeLabel,
    onClick: onRemoveSeat
  }];
  const actionButtons = seatActionButtons.map(({
    type,
    label,
    onClick
  }) => /*#__PURE__*/_jsx(SummaryEditOrRemoveButton, {
    dataTestId: `seatMapSummaryActionsCell-bound-${boundIndex}-segment-${segmentIndex}-traveler-${travelerIndex}-${type}-button`,
    iconType: type,
    label: label,
    onClick: onClick
  }, type));
  let actionButtonContent;
  if (!selectedSeat || Object.keys(selectedSeat).length === 0) {
    actionButtonContent = /*#__PURE__*/_jsxs(LinkButton, {
      className: selectSeatStyles,
      "data-testid": dataTestId('selectSeat', boundIndex, segmentIndex, travelerIndex),
      onClick: onToggleSeatSelect,
      children: [/*#__PURE__*/_jsx(Icon, {
        color: "currentColor",
        id: "plus-circle-thin",
        size: "1rem"
      }), selectLabel]
    }, "selectSeatButton");
  } else if (!isTabletDevice) {
    actionButtonContent = /*#__PURE__*/_jsx(Inline, {
      noWrap: true,
      spacing: 0,
      children: actionButtons
    });
  } else {
    actionButtonContent = /*#__PURE__*/_jsx(Stack, {
      align: "end",
      spacing: 4,
      children: actionButtons
    });
  }
  return /*#__PURE__*/_jsx("td", {
    className: cellStyles,
    children: /*#__PURE__*/_jsx("div", {
      className: actionsWrapperStyles,
      children: actionButtonContent
    })
  });
};
export default SummaryActionsCell;
//# sourceMappingURL=SummaryActionsCell.js.map